import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  async getPulse(devices, type) {
    try {
      const config = {
        params: { device: devices },
        cancelToken: getNewCancelToken(),
      };
      const response = await axiosInstance.get(`/series/device/${type}/pulse`, config);
      return response?.data?.data?.series || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },
};
